module.exports = __webpack_public_path__ + "afdf73d8774a9886d6632a94f94e2002.png";